import { ElementWrapper } from '../../../components/ElementWrapper';
import { StaticWidthInlineEdit } from '../../../components/StaticWidthInlineEdit';
import { IElement } from '../../../models/Element';
import { FormCompanyChange } from './FormCompanyChange';

type FormCompanyChangeFCProps = {
  index: number;
  data: FormCompanyChange;
  updateData: (element: IElement, index: number) => void;
};

export const FormCompanyChangeFC = ({
  index,
  data,
  updateData,
}: FormCompanyChangeFCProps) => {
  const update = (fieldsToUpdate: Partial<FormCompanyChange>) => {
    const updatedData = { ...data, ...fieldsToUpdate };
    updateData(updatedData, index);
  };

  return (
    <ElementWrapper elementIndex={index}>
      <div className="form-interested-in">
        <div className="form-interested-in__content">
          <StaticWidthInlineEdit
            name="title"
            className="title"
            value={data.title}
            setValue={update}
          />

          {/* The field labels below are hardcoded in the API blade template
              and cannot be edited here. */}
          <div className="form-field-group">
            <StaticWidthInlineEdit
              name="heading_primary"
              className="heading-text"
              value={data.heading_primary}
              setValue={update}
            />

            <div className="d-flex justify-content-between gap-4">
              <div className="form-field w-100">
                <a>
                  <span>Naam</span>
                </a>
              </div>

              <div className="form-field w-100">
                <a>
                  <span>Klantnummer</span>
                </a>
              </div>
            </div>

            <div className="d-flex justify-content-between gap-4">
              <div className="form-field w-100">
                <a>
                  <span>Telefoonnummer</span>
                </a>
              </div>

              <div className="form-field w-100">
                <a>
                  <span>E-mailadres</span>
                </a>
              </div>
            </div>
          </div>

          <div className="form-field-group">
            <span className="heading-text">Oude bedrijfsgegevens</span>

            <div className="form-field">
              <a>
                <span>Oude bedrijfsnaam</span>
              </a>
            </div>

            <div className="form-field">
              <a>
                <span>Straat + huisnummer</span>
              </a>
            </div>

            <div className="d-flex justify-content-between gap-4">
              <div className="form-field w-100">
                <a>
                  <span>Postcode</span>
                </a>
              </div>

              <div className="form-field w-100">
                <a>
                  <span>Plaats</span>
                </a>
              </div>
            </div>
          </div>

          <div className="form-field-group">
            <span className="heading-text">Nieuwe bedrijfsgegevens</span>

            <div className="form-field">
              <a>
                <span>Bedrijf (KVK-zoekopdracht of handmatige invoer)</span>
              </a>
            </div>

            <div className="form-field">
              <a>
                <span>E-mailadres nieuwe bedrijf</span>
              </a>
            </div>

            <div className="form-field">
              <a>
                <span>Datum ingang wijziging</span>
              </a>
            </div>
          </div>

          <div className="form-field-group">
            <span className="heading-text">Voor akkoord</span>

            <div className="form-field">
              <a>
                <span>Behandelen als bedrijfsovername</span>
              </a>
            </div>

            <div className="form-field">
              <a>
                <span>Ik ga akkoord</span>
              </a>
            </div>
          </div>

          {/* begin::Action Button */}
          <div className="action">
            <a>
              <span className="action-text">Versturen</span>
            </a>
          </div>
          {/* end::Action Button */}

          <StaticWidthInlineEdit
            name="success_message"
            className="text-white"
            value={
              data.success_message ??
              'We hebben je wijzigingsverzoek ontvangen en nemen dit zo snel mogelijk in behandeling.'
            }
            setValue={update}
          />
        </div>
      </div>
    </ElementWrapper>
  );
};
